import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, " 0 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.basicTimeslot, !_ctx.currentDistricts.length && _ctx.$style.hidden])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentDistricts, (dist) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: dist }, [
        (_ctx.sumData?.[dist])
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.tag)
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.districtName(dist)), 1),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.levelColor(_ctx.sumData[dist]))
              }, _toDisplayString(_ctx.sumData[dist]), 3)
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass([_ctx.$style.tag, 'disable'])
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.districtName(dist)), 1),
              _hoisted_1
            ], 2))
      ], 64))
    }), 128))
  ], 2))
}